import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ImportWizardContainer } from 'pages/importWizard/ImportWizardContainer'
import { z } from 'zod'

const importWizardSearchSchema = z.object({
  importType: z.enum(['ram', 'document', 'pnid']).default('ram'),
  documentID: z.string().optional(),
  pageNumber: z.number().optional(),
  selectedBoxes: z.array(z.string()).optional(),
})

export const Route = createFileRoute('/import-wizard/$siteID')({
  component: RouteComponent,
  validateSearch: importWizardSearchSchema,
  staticData: {
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
    },
  },
})

function RouteComponent() {
  const params = Route.useParams()
  const siteID = params.siteID

  if (!siteID) {
    return <Outlet />
  }

  return <ImportWizardContainer />
}
